import React from "react";
import classNames from "classnames";
import withStyles from "react-jss";

const styles = (theme) => ({
	root: {
		textAlign: "center",
		padding: "0",
		color: "#5812fe",
		borderTop: "solid 1px #e4e8f1",
		fontFamily: theme.fonts.bold,
		textTransform: "uppercase",
		cursor: "pointer",
		height: "50px",
		fontSize: "14px",
		lineHeight: 1,
		letterSpacing: "2px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		"& svg": {
			marginRight: "5px",
		},
	},

	isGrey: {
		color: "#c0bbd2",
	},
	wrapper: {
		width: "100%",
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			width: "50%",
			borderTop: "solid 1px #e4e8f1",
			fontSize: "12px",
		},
		wrapper: {
			width: "50%",
			"& $root": {
				width: "100%",
			},
		},
	},
});

const Component = ({ datatest, wrapper, onClick, grey = false, classes, children }) => {
	if (wrapper) {
		return React.cloneElement(
			wrapper,
			{ className: classes.wrapper },
			<div
				className={classNames(classes.root, {
					[classes.isGrey]: grey,
				})}
				onClick={onClick}
				data-test={datatest}
			>
				{children}
			</div>
		);
	}
	return (
		<div
			className={classNames(classes.root, {
				[classes.isGrey]: grey,
			})}
			onClick={onClick}
			data-test={datatest}
		>
			{children}
		</div>
	);
};

const Button = withStyles(styles)(Component);
Button.displayName = "Button";

export default Button;
